export enum EModuleNames {
  KINO = 'kino',
  DELIVERY = 'delivery',
  NEWS = 'news',
  COVER = 'cover',
}

export type IModule = {
  id: string;
  name: EModuleNames;
  title: string;
  icon?: string;
  isEnabled: boolean;
  isDisplayOnMain: boolean;
};
